import React, { createContext, useContext } from 'react'
import { MARKET, NEWS_CATEGORIES } from './config/ondsConfig'

const DeskContext = createContext(null)

export const ONDS_DESK = {
  ticker: MARKET.ticker,
  companyName: MARKET.companyName,
  sector: MARKET.sector,
  themeClass: '',
  battery: false,
  newsCategories: NEWS_CATEGORIES,
}

export const AMPX_DESK = {
  ticker: 'AMPX',
  companyName: 'Amprius Technologies',
  sector: 'Silicon-Anode Batteries',
  themeClass: 'ampx-theme',
  battery: true,
  newsCategories: [
    { id: 'macro', label: 'Macro' },
    { id: 'sector', label: 'Battery Sector' },
    { id: 'onds', label: 'AMPX' },
  ],
}

export function DeskProvider({ desk, children }) {
  return <DeskContext.Provider value={desk}>{children}</DeskContext.Provider>
}

export function useDesk() {
  return useContext(DeskContext) ?? ONDS_DESK
}
